import { Injectable } from '@angular/core';
import { Observable, distinctUntilChanged, map } from 'rxjs';
import { Store } from './store.model';
import { Feature, Geometry, Position } from '@turf/turf';

import * as turf from '@turf/turf';
import * as _ from 'lodash';
import { TurfHelpers } from '../../shared/helpers/map-turf-helpers';

export interface LineProgressStoreState {
    features: Feature[];
}

@Injectable({
    providedIn: 'root'
})
export class LineProgressStore extends Store<LineProgressStoreState> {
    private _shapeGeometry: Geometry;
    private _vehiclePosition: Position;

    constructor() {
        super({ features: [] });

    }

    public getCurrentFeatures(): Observable<Feature[]> {
        return super.state$.pipe(
            map(state => state.features),
            distinctUntilChanged()
        );
    }

    public setShape(geometry: Geometry) {
        this._shapeGeometry = geometry;
        const features = this._getShapeFeatures();
        if (features) {
            this.setState({
                ...this.stateSnapshot,
                features
            });
        }

    }

    public setPosition(pos: Position) {
        this._vehiclePosition = pos;
        const features = this._getShapeFeatures();
        if (features) {
            this.setState({
                ...this.stateSnapshot,
                features
            });
        }
    }

    public clear() {
        this.setState({
            ...this.stateSnapshot,
            features: []
        });
    }

    private _getShapeFeatures(): turf.Feature[] {
        if (!this._shapeGeometry) {
            return undefined;
        }

        const path: any = _.cloneDeep(this._shapeGeometry as turf.LineString);
        const defaultFeatures = [turf.feature(this._shapeGeometry, {
            zIndex: 10,
            type: 'shape',
            dashed: 'dashed'
        })];

        let pathEndPoint: any = _.last(path.coordinates);
        let pathStartPoint: any = _.first(path.coordinates);

        if (pathEndPoint[0] === pathStartPoint[0]
            && pathEndPoint[1] === pathStartPoint[1]) { // handle circular lines. Due tue turf.lineSlice?
            pathStartPoint = path.coordinates[3];
            pathEndPoint = path.coordinates[path.coordinates.length - 3];
        }

        if (!this._vehiclePosition) {
            return defaultFeatures;
        }

        const currentVehicleCoordinatesOnLine = TurfHelpers.nearestPointOnLine(path, this._vehiclePosition, { units: 'meters' });
        if (currentVehicleCoordinatesOnLine?.properties['dist'] < 20) {
            // split the linestring closest to the vehicle posistion and keep the end part as remaining and the other as passed.
            const remainingPath = TurfHelpers.lineSlice(currentVehicleCoordinatesOnLine, pathEndPoint, path);
            const properties = {
                zIndex: 10,
                type: 'shape'
            };
            remainingPath.properties = _.cloneDeep(properties);
            remainingPath.properties['dashed'] = 'dashed';

            const passedPath = turf.lineSlice(pathStartPoint, currentVehicleCoordinatesOnLine, path);
            passedPath.properties = _.cloneDeep(properties);

            const features = [];

            features.push(remainingPath);
            features.push(passedPath);

            return features;
        }

        // unknown how far we have went, return discrete instead
        return [turf.feature(this._shapeGeometry, {
            zIndex: 10,
            type: 'shape',
            discrete: true
        })];
    }
}
